import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ListView, Toast } from 'antd-mobile'
import { fetchDepotList as fetchDepotListApi } from '@/api/depot'
import { SET_DEPOT } from '@/action-types/depot'
import { setHeader } from '@/util/set-header'
import './select-store.less'

const mapDispatchToProps = (dispatch: any) => ({
  setDepotAction: (payload: any) => dispatch({ type: SET_DEPOT, payload }),
})

@(connect(
  undefined,
  mapDispatchToProps,
) as any)
export default class SelectStore extends Component {
  el!: ListView
  sectionIDs: any = []
  rowIDs: any = []
  dataBlobs: any = {}
  state = {
    stores: [],
    height: 0,
    isLoading: false,
    dataSource: new ListView.DataSource({
      getRowData: (dataBlob: any, _: string, rowID: string) => dataBlob[rowID],
      rowHasChanged: (row1: any, row2: any) => row1 !== row2,
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
    }),
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '选择便利店' })
    if (window.WebViewBridge) {
      window.WebViewBridge?.shouldShowTabBar?.call(window.WebViewBridge, false)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(false)
    }
  }
  componentDidMount() {

    this.setHeight()
    window.locationBack = this.locationBack
    if (window.WebViewBridge) {
      window.WebViewBridge?.getLocation?.call(window.WebViewBridge, 'locationBack')
    } else if (window.webkit) {
      window.webkit.messageHandlers.getLocation.postMessage('locationBack')
    }
    window.addEventListener('resize', this.setHeight)
    // this.locationBack(JSON.stringify({ lat: 121.47, lng: 31.23 }))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setHeight)
    if (window.WebViewBridge) {
      window.WebViewBridge?.shouldShowTabBar?.call(window.WebViewBridge, true)
    } else if (window.webkit) {
      window.webkit.messageHandlers.shouldShowTabBar.postMessage(true)
    }

  }

  locationBack = (argument: any) => {
    if (typeof(argument) === 'string') {
      argument = JSON.parse(argument)
      let lat = argument['lat']
      let lng = argument['lng']
      this.getStores({ lat, lng })
    } else {
      let lat = argument['lat']
      let lng = argument['lng']
      this.getStores({ lat, lng })
    }
  }

  getStores = async (params: Object) => {
    this.setState({ isLoading: true })
    const { data, code, msg } = await fetchDepotListApi(params)
    if (code !== 'SUCCESS') {
      Toast.info(msg)
      return
    }
    const stores = data
    for (let i = 0; i < stores.length; i++) {
      const store = stores[i].list
      const name = stores[i].name
      this.sectionIDs.push(name)
      this.rowIDs[i] = []

      for (let j = 0; j < store.length; j++) {
        const { id } = store[j]
        this.rowIDs[i].push(id)
        this.dataBlobs[id] = store[j]
      }
    }
    this.setState({
      dataSource: this.state.dataSource.cloneWithRowsAndSections(
        this.dataBlobs,
        this.sectionIDs,
        this.rowIDs,
      ),
      isLoading: false
    })
  }
  store = (store: any) => {
    return (
      <div className="store" onClick={() => this.storeClick(store)}>
        <span className="title">{store.title}{store.is_rest ? <span className="store-rest-span">休息中</span> : null}</span>
        <span className="address font-8">地址：{store.address}</span>
        <span className="distance font-8">
          <img src="/public/assets/img/title_location_icon.png" alt="" />
          {store.distance}
          {store.tag && <span className="tag font-8">{store.tag}</span>}
        </span>
      </div>
    )
  }
  storeClick = (store: any) => {
    const { setDepotAction, history }: any = this.props
    const { id, tag, title, is_rest } = store
    if (window.WebViewBridge) {
      window.WebViewBridge?.changeStore?.call(window.WebViewBridge, JSON.stringify(store))
    } else if (window.webkit) {
      window.webkit.messageHandlers.changeStore.postMessage(JSON.stringify(store))
    }
    setDepotAction({ id, tag, title, is_rest })
    history.goBack()
  }

  setHeight = () => {
    const el = document.querySelector('.am-navbar') as HTMLElement
    if (el) {
      const height =
        document.documentElement.clientHeight -
        el.clientHeight - (document.querySelector('.select-store .tips') as HTMLElement).clientHeight
      this.setState({ height })
    }

  }
  render() {
    const { dataSource, isLoading, height } = this.state
    const separator = (sectionID: any, rowID: any) => (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 1,
          borderTop: '0.5px solid #ECECED',
          borderBottom: '0.5px solid #ECECED',
        }}
      />
    )
    return (
      <React.Fragment>
        <div className="select-store">
          <div className="tips font-8">请准确选择合适门店哦！</div>
          {
            isLoading
              ? <div className="stores skeleton">
                {
                  [0, 1, 2, 3, 5].map(i => <div className="store am-list-item" key={`select-store-skeleton${i}`}>
                    <span className="title loading" style={{ width: '25vw' }}>&nbsp;&nbsp;&nbsp;</span>
                    <span className="address font-8 loading" style={{ width: '60vw' }}>&nbsp;&nbsp;&nbsp;</span>
                    <span className="distance font-8 loading" style={{ width: '20vw' }}>
                      &nbsp;&nbsp;&nbsp;
                  </span>
                  </div>)
                }
              </div>
              : <ListView
                ref={el => (this.el = el as ListView)}
                className="stores"
                dataSource={dataSource}
                renderRow={this.store}
                renderSeparator={separator}
                renderSectionHeader={(_, sectionID) => {
                  return <div className="stores-title">{sectionID}</div>
                }}
                initialListSize={Object.keys(this.dataBlobs).length}
                style={{
                  height,
                  overflow: 'auto',
                }}
              />
          }
        </div>
      </React.Fragment>
    )
  }
}
